var languageType = require('./languageCommon.js')
var language = localStorage.getItem('language') || 'zh-CN'
require('../home.css');
require('../en.css');
require('../less/quanjingList.less');
require('./sensorsdata.js')
var panoramaData = require('./panoramaImages.js');

if(language=='zh-CN'){
  $('body').removeClass('en')
}else{
  $('body').addClass('en')
}

$('.commonPanorama').addClass('select');
$('.reservation').css('color','white');

$(".about1").on('mouseover', function () {
  $(".aboutLv").show();
});
$(".about1").on('mouseout', function () {
  $(".aboutLv").hide();
});
$(".brand1").on('mouseover', function () {
  $(".choiceBrand").show();
}).on('mouseout', function () {
  $(".choiceBrand").hide();
});

$('.language').on('mouseover',function() {
  $(".choicelanguage").show();
}).on('mouseout',function() {
  $(".choicelanguage").hide();
})
$('.choicelanguage a').eq(0).on('click',function(){
  window.location.href = window.location.origin+window.location.pathname+'?locale=zh-CN'
  localStorage.setItem('language','zh-CN')
})
$('.choicelanguage a').eq(1).on('click',function(){
  localStorage.setItem('language','USA');
  window.location.href = window.location.origin+window.location.pathname+'?locale=USA'
})
$('.choicelanguage a').eq(2).on('click',function(){
  localStorage.setItem('language','JP');
  window.location.href = window.location.origin+window.location.pathname+'?locale=JP'
})
$('.choicelanguage a').eq(3).on('click',function(){
  localStorage.setItem('language','KO');
  window.location.href = window.location.origin+window.location.pathname+'?locale=KO'
})
$('.choicelanguage a').eq(4).on('click',function(){
  localStorage.setItem('language','TH');
  window.location.href = window.location.origin+window.location.pathname+'?locale=TH'
})

function buildPanoramaList() {
  var cards = panoramaData.gridCards;
  var locale = localStorage.getItem('language') || 'zh-CN';
  var localeParam = '?locale=' + locale;
  var html = '';
  cards.forEach(function (card) {
    var columnStyle = card.columnIndex ? ' style="grid-column:' + card.columnIndex + ';"' : '';
    html += '<a class="panorama_card is-loading"' + columnStyle + ' href="./quanjingDetail.html' + localeParam + '&scene=' + encodeURIComponent(card.sceneKey) + '">';
    html += '<div class="panorama_card_media">';
    html += '<img data-src="' + card.coverSrc + '" alt="' + card.coverName + '" loading="lazy"/>';
    html += '</div>';
    html += '<span class="panorama_card_status panorama_card_status--loading">加载中</span>';
    html += '<span class="panorama_card_status panorama_card_status--error">加载失败</span>';
    html += '</a>';
  });
  $('[data-role="panorama-grid"]').html(html);
}

function bindImageState($img) {
  var $card = $img.closest('.panorama_card');
  $img.on('load', function () {
    $card.removeClass('is-loading').removeClass('is-error');
  });
  $img.on('error', function () {
    $card.removeClass('is-loading').addClass('is-error');
  });
}

function loadImage($img) {
  var src = $img.attr('data-src');
  if (!src || $img.attr('src')) {
    return;
  }
  $img.attr('src', src);
}

function initLazyLoad() {
  var $images = $('.panorama_card img');
  
  $images.each(function () {
    bindImageState($(this));
  });
  
  // 列表页直接加载所有图片
  $images.each(function () {
    loadImage($(this));
  });
}

$(function () {
  buildPanoramaList();
  initLazyLoad();
});



/** WEBPACK FOOTER **
 ** ./src/js/quanjingList.js
 **/